import { Icon } from '@lmc/ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { LabelIcon } from '../../../../../components/generic'
import { getTextFill } from '../../../utils/medicationRoundsRowUtils'

const renderNotAdministered = (props) => {
  const { notAdministered } = props

  return (
    <div style={styles.notAdministeredContainer}>
      <div style={styles.notAdministered}>
        <LabelIcon
          boldText={notAdministered}
          text={'Not administered'}
          textFill={getTextFill(notAdministered)}
        />
      </div>
    </div>
  )
}

const renderPRN = (props) => {
  const { PRN } = props

  return (
    <div style={styles.PRNContainer}>
      <div style={styles.PRN}>
        <LabelIcon boldText={PRN} text={'PRN'} textFill={getTextFill(PRN)} />
      </div>
    </div>
  )
}

const renderChevron = (props) => {
  const { isDailyTotal, isEmptyRow, isOpen } = props

  const iconName = isOpen ? 'UpOutlined' : 'DownOutlined'

  const chevronStyles =
    isDailyTotal || isEmptyRow
      ? { ...styles.chevron, color: 'transparent' }
      : styles.chevron

  return <Icon name={iconName} style={chevronStyles} />
}

// Main render function
/**
@description Renders details column cell.

@param {number} notAdministered. The residents who haven't taken all
their meds.

@param {number} PRN. The residents who have had prn meds.

@param {bool} isEmptyRow. True if row has no values,
i.e. there are no residents for that round.

@param {bool} isOpen. True if row is last row in table.

@param {bool} isDailyTotal. True if row is Daily Total row.

@returns {function} DetailsColumnCell
*/

export default function DetailsColumnCell(props) {
  return (
    <div style={styles.detailsColumn}>
      {renderNotAdministered(props)}
      {renderPRN(props)}
      {renderChevron(props)}
    </div>
  )
}

DetailsColumnCell.propTypes = {
  PRN: PropTypes.number.isRequired,
  isDailyTotal: PropTypes.bool,
  isEmptyRow: PropTypes.bool,
  isOpen: PropTypes.bool,
  notAdministered: PropTypes.number.isRequired
}

const styles = {
  chevron: {
    fontSize: 11
  },
  detailsColumn: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    lineHeight: '22px',
    width: 420
  },
  notAdministered: {
    width: 150
  },
  notAdministeredContainer: {
    flexGrow: 1
  },
  PRN: {
    width: 75
  },
  PRNContainer: {
    flexGrow: 2
  }
}
